import type { InsuranceFeatures } from '../types/InsuranceFeatures';

export const phoebeFlags: InsuranceFeatures = {
    insurances: {
        enabled: false,
        _description: 'Main feature flag to enable fetch and visibility of the insurances',
        papiCustomization: {
            enabled: false,
            _description: 'Enables usage of PAPI customization.',
        },
        microservice: {
            claims: {
                enabled: false,
                _description: 'Enable insurance claims microservice usage',
            },
            payment: {
                enabled: false,
                _description: 'Enable insurance payment microservice usage',
            },
        },
    },
    insurancesPaymentAmount: {
        enabled: false,
        _description: 'Enables premium of blue feature',
    },
};
